















































































import {
  Vue,
  Component,
  Watch,
  Prop,
} from "@/shared/vuepack";

import Pagination from "@/shared/components/ui/Pagination.vue";
import ClaimRow from "@/employee/components/healthcareExpense/ClaimRow.vue";
import HealthcareExpenseNavigation from "@/employee/components/healthcareExpense/HealthcareExpenseNavigation.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { RawLocation } from "vue-router";
import { useClaimStore } from "@/employee/store/claim";
import { useDeductibleTrackerStore } from "@/employee/store/deductibleTracker";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Pagination,
    ClaimRow,
    HealthcareExpenseNavigation,
    GenericLoadingSpinner
  },
})

export default class HealthcareExpenseClaims extends Vue {
  claimStore = useClaimStore();
  deductibleTrackerStore = useDeductibleTrackerStore();
  userStore = useUserStore();

  @Prop()
  SettingsRoute: RawLocation;

  mounted () {
    this.userStore.loadPartnerSettings();
    this.loadPage();
    this.deductibleTrackerStore.retrieveHealthPlanIsLinked();
  }

  @Watch("$props", { deep: true })
  loadPage () {
    this.claimStore.loadClaims({
      pageNumber: this.claimStore.currentPage,
    }).catch(() => null); // the store rethrows the error
  }

  onSwitchPage (pageNumber): void {
    this.claimStore.setPageNumber(pageNumber);
    this.claimStore.loadClaims({ pageNumber });
  }

  toSettings () {
    this.$router.push(this.SettingsRoute);
  }
}
